import config from '../utils/apiconfig';
import request from '../utils/request';

const {api} = config;
const {sewageOutlet, sewageOutletId, sewageOutletMapData} = api;

/**
 * 查询列表
 */
export async function list(params) {
  return request({url: sewageOutlet, method: 'get', data: params,});
}


export async function getMapData(params) {
  return request({url: sewageOutletMapData, method: 'get', data: params,});
}


/**
 * 查询详情
 */
export async function getDetail(paramId) {
  return request({
    url: sewageOutletId, method: 'get', data: {
      id: paramId
    },
  });
}

/**
 * 编辑
 */
export async function edit(params) {
  return request({url: sewageOutletId, method: 'put', data: params});
}

/**
 * 删除
 */
export async function deleteItem(params) {
  return request({url: sewageOutlet+ '/delete' , method: 'post', data: params});
}

/**
 * 创建
 */
export async function createItem(params) {
  return request({url: sewageOutlet, method: 'post', data: params,});
}
